export default __webpack_public_path__ + "4bb11c5284b1a5cd4e3153cb27c9cba2.png";